<template>
    <div @click="showPopMenu" class="common_box" style="position: relative; line-height: 24px; color: #bbbbbb; font-weight: 500; width: 120px; display: flex; align-items: center; gap: 12px; justify-content: space-between">
        <div :style="{ color: initRole === '' ? '' : '#210f03' }" style="font-size: 14px">{{ initRole === "" ? "선택" : initRole }}</div>
        <img style="width: 10px; transform: rotate(90deg)" :src="require('@/assets/img/arrow_tick.png')" alt="" />
        <MemberTalkPopMenuOption v-if="isShowPopMenu" :right="0" :top="43" v-bind="popMenuOptions" :width="'120px'"></MemberTalkPopMenuOption>
    </div>
</template>

<script>
    import MemberTalkPopMenuOption from "./MemberTalkPopMenuOption";
    export default {
        name: "CoachCareerRoleSelector",
        components: {MemberTalkPopMenuOption},
        props : {
            setRole : {
                type : Function,
                default : () => {},
            },
            initRole : {
                type : String,
                default : ''
            }

        },
        data(){
            return {
                isShowPopMenu : false,
            }
        },
        methods : {
            showPopMenu(){
                this.isShowPopMenu = true;
            }
        },
        created(){
            const roles = ['선수', '코치'];

            const labelAndAction = [];
            for(const each of roles){
                labelAndAction.push(
                    {
                        label: each,
                        action: async () => {
                            this.setRole(each);
                            this.isShowPopMenu = false;
                        },
                        fontColor: "#210f03",
                    }
                )
            }

            this.popMenuOptions = {
                labelAndAction: labelAndAction,
                closeAction: () => {
                    this.isShowPopMenu = false;
                },
            };
        }

    }
</script>

<style scoped>
    .common_box {
        padding: 12px;
        background-color: #f5f5f5;
        border-radius: 12px;
    }
</style>